import { IMY24ProductExteriorInterior } from '@/components/sections/my24/product/exterior-interior-x-series';
import { ProductHeroBannerXSeriesProps } from '@/components/sections/my24/product/hero-banner-x-series';
import { IMY24ProductLineup } from '@/components/sections/my24/product/lineup-carousel';
import { IMY24ProductNavigation } from '@/components/sections/my24/product/navigation';
import { IMY24ProductSafetyInnovation } from '@/components/sections/my24/product/safety-innovation';
import { IMY24ProductVideo } from '@/components/sections/my24/product/video';
import type { ProductCustomizeProps } from '@/components/shared/product-customize';
import {
  getModelLineupId,
  PRODUCT_LINEUP_DATA,
  X_SERIES_DATA,
  X_SERIES_MENU,
} from '@/contents/lcv/product/bluepower/shared/lineup';
import { getCta } from '@/contents/lcv/product/maxforce/shared/cta';

export const DATA = {
  META_TAG_DATA: {
    title:
      'อีซูซุ เอ็กซ์-ซีรี่ส์ ISUZU X-SERIES - อีซูซุประเทศไทย Isuzu Thailand Official',
    description: 'อีซูซุ เอ็กซ์-ซีรี่ส์ ISUZU X-SERIES แรง...ทะลุเวิร์ส',
    img: {
      url: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltf7d4b7cb1ed65b76/65a64d4a5a14f284ee183aa9/og-x-series.jpg',
    },
  },
  PRODUCT_HERO_BANNER_DATA: {
    active: true,
    menu: {
      hash: '#',
      label: 'ภาพรวม',
    },
    headline: {
      preTitle: '',
      title: 'อีซูซุ เอ็กซ์-ซีรี่ส์ ISUZU X-SERIES แรง...ทะลุเวิร์ส',
      description: '',
      buttons: [],
    },
    items: [
      {
        summary: [
          {
            preTitle: 'เครื่องยนต์',
            title: '1.9 Ddi',
          },
          {
            preTitle: 'แรงม้า',
            title: '150 hp',
          },
          {
            preTitle: 'เริ่มต้น',
            title: X_SERIES_DATA.price,
          },
        ],
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt7de23864581646a1/65a64ca151c7576d7252ec52/x-series-banner.jpg',
          alt: 'Isuzu X-series Gotta Xross The Line!',
        },
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        imageDesktop: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blte20af4989f79eb1c/65a739d5c7bb1696b8a285e4/x-series-banner-desktop.jpg',
          alt: 'Isuzu X-series Gotta Xross The Line!',
        },
        logo: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt0ce9a8fb9081feb0/65b64afe08561627ea5e07b4/logo-isuzu-x-series.png',
          alt: 'Isuzu X-series Gotta Xross The Line!',
          width: 260,
          height: 62,
        },
        logoDesktop: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt0ce9a8fb9081feb0/65b64afe08561627ea5e07b4/logo-isuzu-x-series.png',
          alt: 'Isuzu X-series Gotta Xross The Line!',
          width: 340,
          height: 80,
        },
        title: 'อีซูซุ เอ็กซ์-ซีรี่ส์',
        buttons: [
          {
            label: 'ข้อเสนอพิเศษ',
            url: '/specialoffer/pup/x-series-speed-financial',
            border: true,
            isMinWidth: true,
            color: 'button-white',
          },
          {
            label: 'เปรียบเทียบรุ่นรถ',
            url: '/compare?model=x-series-speed-4-door-mt&model=v-cross-3-0-ddi-m-4-door-at&model=mu-x-4x4-3-0-ultimate-phantom-collection',
            isMinWidth: true,
            color: 'button-gray',
          },
        ],
      },
    ],
  } satisfies ProductHeroBannerXSeriesProps,
  PRODUCT_VIDEO_DATA: {
    active: true,
    model: 'x-series',
    menu: {
      hash: '#video',
      label: 'วิดีโอ',
    },
    headline: {
      preTitle: '',
      title: 'อีซูซุ เอ็กซ์-ซีรี่ส์',
      description: '',
      buttons: [],
    },
    item: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      image: {
        src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta1e226dd3314117a/65a9b35acdbb968a6bc504aa/x-series-cover.jpg',
        alt: 'Isuzu X-series Gotta Xross The Line!',
      },
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      imageDesktop: {
        src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt53843e5680963db7/65a9b35a14eace44efa5b1aa/x-series-cover-desktop.jpg',
        alt: 'Isuzu X-series Gotta Xross The Line!',
      },
      video: {
        src: 'https://assets.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltc6d8f4a5d1a7c758/65a9b35c7fc0005be4223f29/x-series-video.mp4',
      },
      videoDesktop: {
        src: 'https://assets.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt05219b63a330f641/65a9b35c573161bd53cc7a1f/x-series-video-desktop.mp4',
      },
      youtube: {
        label: 'ดูวิดีโอแบบเต็ม',
        url: '71hG0N3FGL4',
        icon: 'play-round',
      },
      preTitle: 'อีซูซุ เอ็กซ์-ซีรี่ส์',
      title: 'แรง...ทะลุเวิร์ส',
      description: '',
      buttons: [],
    },
  } satisfies IMY24ProductVideo,
  PRODUCT_EXTERIOR_DATA: {
    active: true,
    theme: 'dark',
    section: 'exterior',
    menu: {
      hash: '#exterior',
      label: 'ดีไซน์ภายนอก',
    },
    tabs: [
      {
        value: 'speed',
        logoActive: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt09c838dc4407358f/656d9b53107d421a6ab807fe/logo-speed-active.svg',
          alt: 'Speed',
          width: 152,
          height: 24,
        },
        logoDefault: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltab865383f58ea98b/656d9b537c56ddf0caa627c7/logo-speed.svg',
          alt: 'Speed',
          width: 152,
          height: 24,
        },
        headline: {
          preTitle: 'ดีไซน์ภายนอก',
          title: 'EXTERIOR',
          description:
            '<p>ปิกอัพสปอร์ตแนวสตรีทเรซกับไอเทมรอบคัน <span>ให้คุณสนุก</span><span>เร้าใจ</span> <span>มันส์ทะลุเวิร์ส</span> กับทุกสปีดที่ใจต้องการ</p>',
          buttons: [
            {
              label: 'เปรียบเทียบรุ่นรถ',
              url: '/compare?model=x-series-speed-4-door-mt&model=v-cross-3-0-ddi-m-4-door-at&model=mu-x-4x4-3-0-ultimate-phantom-collection',
              isMinWidth: true,
              color: 'button-white',
              border: true,
            },
          ],
        },
        highlight: {
          bg: {
            src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt6fec66d923d17551/65a7c206df87337334cda6dc/speed-bg.jpg',
            alt: 'Speed Exterior',
          },
          bgDesktop: {
            src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt4e3df8c7eb6931a8/65a25f8243e8cb7a75a4c165/speed-bg.jpg',
            alt: 'Speed Exterior',
          },
          car: {
            src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt976da79e6939430a/65a25ea5711b3133cffcbee4/speed-car.png',
            alt: 'Speed Exterior',
          },
          character: {
            src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt743a6107f6e7e644/65a25ebd363d3f781f458b10/speed-character.png',
            alt: 'Speed Exterior',
          },
        },
        items: [
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta741b0dba8c3a03e/65a7cc6d41047f53e84e6f53/speed-exterior-1-front-grill.jpg',
              alt: 'Speed Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt6ed09d85dc054969/65a7cc6d7fc000e3ef223484/speed-exterior-1-front-grill-desktop.jpg',
              alt: 'Speed Exterior',
            },
            title: 'กระจังหน้าแบบ 3-Dimension',
            description:
              '<p>โดดเด่นสไตล์สปอร์ตด้วยดีไซน์โทนเข้มตัดแดง Garnet Red</p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb2b978885723431f/65a7cc6dc992b77320b89edb/speed-exterior-2-sticker.jpg',
              alt: 'Speed Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt720d503e2bab9ca7/65a7cc6edaaa50486c9c784b/speed-exterior-2-sticker-desktop.jpg',
              alt: 'Speed Exterior',
            },
            title: 'สติกเกอร์ Dual Stripes คาด<span>หน้า-หลัง</span>',
            description:
              '<p>เท่ โดดเด่น ตามเอกลักษณ์สไตล์ X-SERIES <span>ตัวจริง</span></p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt9a24e499fc5f1fee/65af4c2ec1930fa787f8c4ec/speed-exterior-3-skirt-front.jpg',
              alt: 'Speed Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt4ca91ed83e4ed339/65af4c181e1aed5356fd5896/speed-exterior-3-skirt-front-desktop.jpg',
              alt: 'Speed Exterior',
            },
            image2: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt9869088eda8f0b54/65af4c5ba0613d816952b2b4/speed-exterior-3-skirt-back.jpg',
              alt: 'Speed Exterior',
            },
            imageDesktop2: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt82a8b13dab877a35/65af4c489b1ffe4be7e0f221/speed-exterior-3-skirt-back-desktop.jpg',
              alt: 'Speed Exterior',
            },
            title:
              'สเกิร์ตหน้า-หลัง สไตล์ Integrated พร้อม<span>สเกิร์ตข้าง</span>',
            description: '<p>ดีไซน์เฉพาะตัว สะดุดตา เติมอารมณ์สปอร์ต</p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt101c68cce490a631/65a7cc6edf8733b6c3cda717/speed-exterior-4-isuzu-vision-bi-led.jpg',
              alt: 'Speed Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt9dcdcbebb839f742/65a7cc6da0613d671f529904/speed-exterior-4-isuzu-vision-bi-led-desktop.jpg',
              alt: 'Speed Exterior',
            },
            title: 'ใหม่! ไฟหน้า ISUZU Vision Bi-LED',
            description:
              '<p>ดีไซน์โฉบเฉี่ยว พร้อม Multifunctional Daylight ทําหน้าที่ทั้ง Daylight <span>ไฟหรี่</span> <span>ไฟเลี้ยว</span></p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb0647241bf2108a9/65a7cc6d13079041b4cbf763/speed-exterior-5-alloy-wheel.jpg',
              alt: 'Speed Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt787f7b9bc6f2cece/65a7cc6d18af002bcf0a75cd/speed-exterior-5-alloy-wheel-desktop.jpg',
              alt: 'Speed Exterior',
            },
            title: 'ใหม่! ล้ออัลลอยขนาด 16 นิ้ว',
            description:
              '<p>สี Gloss Black พร้อมโลโก้ ISUZU <span>สีแดง</span> <span>เท่เกินต้าน</span></p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt68dd13b662dac9ea/65a7cc6ea0613d0179529908/speed-exterior-6-air-curtain.jpg',
              alt: 'Speed Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt548e80f171acb7af/65a7cc6dc7bb16f789a28837/speed-exterior-6-air-curtain-desktop.jpg',
              alt: 'Speed Exterior',
            },
            title: 'ใหม่! Air Curtain ที่<span>สเกิร์ต</span>ด้านหน้า',
            description:
              '<p>ช่วยเพิ่ม Aerodynamic ลดแรงต้านอากาศ แบบฉบับรถ<span>สปอร์ตหรู</span></p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt4189df39784ea138/65a7cc6e02a665a76f92bff0/speed-exterior-7-tail-light.jpg',
              alt: 'Speed Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltf756928d03a0d0f6/65a7cc6e14eace7459a5a64d/speed-exterior-7-tail-light-desktop.jpg',
              alt: 'Speed Exterior',
            },
            title: 'ใหม่! ไฟท้ายแบบ Triple-Armour LED',
            description: '<p>สัญลักษณ์ใหม่แห่งความโดดเด่น</p>',
          },
        ],
      },
      {
        value: 'hilander',
        logoActive: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt83354b438b95f973/656d9b537c56dd6e47a627c3/logo-hi-lander-active.svg',
          alt: 'Hi-Lander',
          width: 230,
          height: 24,
        },
        logoDefault: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltd6164bdf09718c76/656d9b5352b29b01985c3520/logo-hi-lander.svg',
          alt: 'Hi-Lander',
          width: 230,
          height: 24,
        },
        headline: {
          preTitle: 'ดีไซน์ภายนอก',
          title: 'EXTERIOR',
          description:
            '<p>ดีไซน์ใหม่! ออกแบบให้ทุก Element โดดเด่น <span>ไม่เหมือนใคร</span> <span>ให้คุณสนุก</span><span>เร้าใจ</span> ไปกับการโลดแล่น<span>นอกกรอบ</span></p>',
          buttons: [
            {
              label: 'เปรียบเทียบรุ่นรถ',
              url: '/compare?model=x-series-hi-lander-4-door-at&model=v-cross-3-0-ddi-m-4-door-at&model=mu-x-4x4-3-0-ultimate-phantom-collection',
              isMinWidth: true,
              color: 'button-white',
              border: true,
            },
          ],
        },
        highlight: {
          bg: {
            src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt738b95af5edd6b34/65a7c23bcfd284d618f1bea9/hi-lander-bg.jpg',
            alt: 'Hi-Lander Exterior',
          },
          bgDesktop: {
            src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltbc13958c9bb39d5d/65a25fded838b3917f9d9164/hi-lander-bg.jpg',
            alt: 'Hi-Lander Exterior',
          },
          car: {
            src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt22068bc00a3ffe1d/65b32cfa417875ab33674bd6/hi-lander-car.png',
            alt: 'Hi-Lander Exterior',
          },
          character: {
            src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt3c3e927edf41dc9a/65a25e8f51c757256552e3ee/hi-lander-character.png',
            alt: 'Hi-Lander Exterior',
          },
        },
        items: [
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt9d50e862bdba0aab/65a7b184a933e50fa402636a/hi-lander-exterior-1-front-grill.jpg',
              alt: 'Hi-Lander Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt22f7ef3db772dcdc/65a7b183df873310f3cda6a7/hi-lander-exterior-1-front-grill-desktop.jpg',
              alt: 'Hi-Lander Exterior',
            },
            title: 'กระจังหน้าแบบ 3-Dimension',
            description:
              '<p>โดดเด่นสไตล์สปอร์ตด้วยดีไซน์โทนเข้มตัดแดง Garnet Red</p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta68304c35968771b/65a7b183d48d3d80cacec134/hi-lander-exterior-2-sticker.jpg',
              alt: 'Hi-Lander Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt8b75203f24db9443/65a7b1839b1ffe2104e0d6be/hi-lander-exterior-2-sticker-desktop.jpg',
              alt: 'Hi-Lander Exterior',
            },
            title: 'สติกเกอร์ Dual Stripes คาด<span>หน้า-หลัง</span>',
            description: '<p>คมเข้ม เท่เป็นเอกลักษณ์</p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt8541770342b578bf/65af4cb2c992b74409b8bb55/hi-lander-exterior-3-skirt-front.jpg',
              alt: 'Hi-Lander Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt4cbf378087ab8c81/65af4ca5bad37dbcac9e1288/hi-lander-exterior-3-skirt-front-desktop.jpg',
              alt: 'Hi-Lander Exterior',
            },
            image2: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltf40df37bdeb17fad/65af4c9adaaa5002679c9322/hi-lander-exterior-3-skirt-back.jpg',
              alt: 'Hi-Lander Exterior',
            },
            imageDesktop2: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt2291b5468bf42441/65af4c8e02a66531fd92dd48/hi-lander-exterior-3-skirt-back-desktop.jpg',
              alt: 'Hi-Lander Exterior',
            },
            title: 'กันชนพร้อมสเกิร์ตหน้า-หลัง สไตล์ Integrated',
            description: '<p>ดีไซน์เท่ ให้อารมณ์สปอร์ตพรีเมียม</p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt46ebd8dd2a416848/65a7b183dbd0c3b85ead2abc/hi-lander-exterior-4-aerodynamic-sport-bar.jpg',
              alt: 'Hi-Lander Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltad6006e5e42215d6/65a7b183a933e519f8026366/hi-lander-exterior-4-aerodynamic-sport-bar-desktop.jpg',
              alt: 'Hi-Lander Exterior',
            },
            title: 'Aerodynamic Sport Bar เหนือกระบะท้าย',
            description:
              '<p>ยกอารมณ์สปอร์ตอีกระดับ พร้อมความ<span>โฉบเฉี่ยว</span><span>ลู่ลม</span></p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt2002bf71cb0f35ce/65a7b182cdbb960b22c4f94e/hi-lander-exterior-5-isuzu-vision-bi-led.jpg',
              alt: 'Hi-Lander Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt0666fd1646c61c14/65a7b184d48d3d462ccec138/hi-lander-exterior-5-isuzu-vision-bi-led-desktop.jpg',
              alt: 'Hi-Lander Exterior',
            },
            title: 'ใหม่! ไฟหน้า ISUZU Vision Bi-LED',
            description:
              '<p>ดีไซน์โฉบเฉี่ยว พร้อม Multifunctional Daylight ทําหน้าที่ทั้ง Daylight <span>ไฟหรี่</span> <span>ไฟเลี้ยว</span></p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt00b2d0974d0aca61/65a7b44f5731611ff5cc6e9f/hi-lander-exterior-6-alloy-wheel.jpg',
              alt: 'Hi-Lander Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltf750d3fcf9b95054/65a7b434a933e5ab07026373/hi-lander-exterior-6-alloy-wheel-desktop.jpg',
              alt: 'Hi-Lander Exterior',
            },
            title: 'ใหม่! ล้ออัลลอยขนาด 18 นิ้ว<sup>*</sup>',
            description:
              '<p>ดีไซน์เท่ เสริมความสปอร์ตพรีเมียม <span>โดดเด่น</span>ด้วยโลโก้ ISUZU <span>สีแดง</span>  <span>เท่เกินต้าน</span></p><p><small><sup>*</sup>ในรุ่น 4 ประตู</small></p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt33bc20d23a69e8f8/65a7b3e8130790e863cbf6e0/hi-lander-exterior-7-air-curtain.jpg',
              alt: 'Hi-Lander Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt838786900b8ad5c0/65a7b3fd5731614470cc6e9d/hi-lander-exterior-7-air-curtain-desktop.jpg',
              alt: 'Hi-Lander Exterior',
            },
            title: 'ใหม่! Air Curtain ที่<span>สเกิร์ต</span>ด้านหน้า',
            description:
              '<p>Aerodynamic ลดแรงต้านอากาศ แบบฉบับรถ<span>สปอร์ตหรู</span></p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt48dcf12c9fdb6d3a/65a7b39edf8733412ccda6b7/hi-lander-exterior-8-tail-light.jpg',
              alt: 'Hi-Lander Exterior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt8dfe83d7e500656f/65a7b3b8cfd2848c71f1be7c/hi-lander-exterior-8-tail-light-desktop.jpg',
              alt: 'Hi-Lander Exterior',
            },
            title: 'ใหม่! ไฟท้ายแบบ Triple-Armour LED',
            description: '<p>สัญลักษณ์ใหม่แห่งความโดดเด่น</p>',
          },
        ],
      },
    ],
  } as IMY24ProductExteriorInterior,
  PRODUCT_INTERIOR_DATA: {
    active: true,
    theme: 'dark',
    section: 'interior',
    menu: {
      hash: '#interior',
      label: 'ดีไซน์ภายใน',
    },
    tabs: [
      {
        value: 'speed',
        logoActive: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt09c838dc4407358f/656d9b53107d421a6ab807fe/logo-speed-active.svg',
          alt: 'Speed',
          width: 152,
          height: 24,
        },
        logoDefault: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltab865383f58ea98b/656d9b537c56ddf0caa627c7/logo-speed.svg',
          alt: 'Speed',
          width: 152,
          height: 24,
        },
        headline: {
          preTitle: 'ดีไซน์ภายใน',
          title: 'INTERIOR',
          description:
            '<p>ความเร้าใจใหม่! สัมผัสไปกับ <span>X-Package</span> ดีไซน์ล่าสุด <span>ยกระดับ</span>ความโฉบเฉี่ยว <span>เต็มอารมณ์</span><span>สตรีทเรซ</span></p>',
          buttons: [
            {
              label: 'คำนวณค่างวด',
              url: '/calculator?model=x-series',
              border: true,
              isMinWidth: true,
              color: 'button-white',
            },
          ],
        },
        highlight: {
          bg: {
            src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta5eb2d74ab15c802/65a651af43e8cb8baca4c96d/speed-bg.jpg',
            alt: 'Speed Interior',
          },
          bgDesktop: {
            src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt13bc491aa79008c5/65ae255e02a665426292d6f0/speed-bg-desktop.jpg',
            alt: 'Speed Interior',
          },
        },
        items: [
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb337c1ca53ba4067/65a779759b1ffe66cee0d55f/speed-interior-1-dial.jpg',
              alt: 'Speed Interior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt8495b2424c6f6fae/65a77975b5610421828c239f/speed-interior-1-dial-desktop.jpg',
              alt: 'Speed Interior',
            },
            title: 'ใหม่! หน้าปัดแสดงข้อมูลสไตล์เรซซิ่ง',
            description: '<p>ดีไซน์พิเศษ​ สะท้อนตัวตนผ่านโลโก้ X</p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt2ecb2bd868bf6a26/65a779759b1ffe7d0fe0d563/speed-interior-2-infotainment-display.jpg',
              alt: 'Speed Interior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt434a1410d6e64a7c/65a779771e1aed8638fd3c66/speed-interior-2-infotainment-display-desktop.jpg',
              alt: 'Speed Interior',
            },
            title: 'ใหม่! หน้าจอระบบสัมผัส Infotainment <span>8 นิ้ว</span>',
            description:
              '<p>ดีไซน์สปอร์ตโทนแดง รองรับระบบ Wireless Android Auto<sup>*</sup> และ Wireless Apple CarPlay<sup>*</sup> หน้าจอทำงานแบบ Multitasking System เชื่อมต่อข้อมูลกับ Integrated MID แสดงผลได้หลากหลายฟังก์ชัน</p><p><small><sup>*</sup>เฉพาะสมาร์ทโฟนรุ่นที่รองรับการใช้งาน</small></p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt2e5c8c8329d188a0/65ab35ff1e1aed881efd4f74/speed-interior-3-console.jpg',
              alt: 'Speed Interior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltc1404399f15dafbb/65ab35e7a933e57542027599/speed-interior-3-console-desktop.jpg',
              alt: 'Speed Interior',
            },
            title: 'ใหม่! คอนโซลดีไซน์แบบ Flaming Wing',
            description:
              '<p>เพิ่มความเร้าใจ ด้วยโลโก้ X พร้อม Gradient <span>สีดำ-แดง</span></p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta618550a0a56aa65/65a77975dbd0c328edad2970/speed-interior-4-seat.jpg',
              alt: 'Speed Interior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt6dfa5473e4ff4ca5/65a7797641047f46e64e6d9c/speed-interior-4-seat-desktop.jpg',
              alt: 'Speed Interior',
            },
            title: 'ใหม่! เบาะนั่งดีไซน์สปอร์ตทูโทน<span>ดำ-แดง</span>',
            description:
              '<p>ทรงสปอร์ต โอบกระชับ พร้อมโลโก้ X สีแดง<span>สุดเท่</span>ที่เบาะคู่หน้า</p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltada0c3197f5fd66b/65ab362ba933e57f2402759b/speed-interior-5-gear.jpg',
              alt: 'Speed Interior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt2041d76c57be430b/65ab3617a0613d764f52a9a1/speed-interior-5-gear-desktop.jpg',
              alt: 'Speed Interior',
            },
            title: 'ชุดคันเกียร์พร้อมเบรกมือ',
            description:
              '<p>ดีไซน์พิเศษหุ้มหนังเดินด้ายแดง เสริมอารมณ์สปอร์ตด้วยกรอบโทนสีแดง</p>',
          },
        ],
      },
      {
        value: 'hilander',
        logoActive: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt83354b438b95f973/656d9b537c56dd6e47a627c3/logo-hi-lander-active.svg',
          alt: 'Hi-Lander',
          width: 230,
          height: 24,
        },
        logoDefault: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltd6164bdf09718c76/656d9b5352b29b01985c3520/logo-hi-lander.svg',
          alt: 'Hi-Lander',
          width: 230,
          height: 24,
        },
        headline: {
          preTitle: 'ดีไซน์ภายใน',
          title: 'INTERIOR',
          description:
            '<p>ปิกอัพสปอร์ตยกสูง <span>โดนใจ</span><span>คนจริง</span> ให้คุณสนุก<span>เกินคาด</span><span>กับทุก</span>เส้นทางเหนือจินตนาการ</p>',
          buttons: [
            {
              label: 'คำนวณค่างวด',
              url: '/calculator?model=x-series',
              border: true,
              isMinWidth: true,
              color: 'button-white',
            },
          ],
        },
        highlight: {
          bg: {
            src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt14e96606ef34075b/65a65000d2ebff4e076f5163/hi-lander-bg.jpg',
            alt: 'Hi-Lander Interior',
          },
          bgDesktop: {
            src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt6a370af3620708df/65ae2579d48d3d314dced65e/hi-lander-bg-desktop.jpg',
            alt: 'Hi-Lander Interior',
          },
        },
        items: [
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt55a1b46adb9f1a39/65a7798dfb10605d63a4044e/hi-lander-interior-1-integrated-mid.jpg',
              alt: 'Hi-Lander Interior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt06c2950fb331ef2d/65a7798d8c124ac1e515960b/hi-lander-interior-1-integrated-mid-desktop.jpg',
              alt: 'Hi-Lander Interior',
            },
            title: 'ใหม่! หน้าจอแสดงข้อมูล Integrated MID <span>7 นิ้ว</span>',
            description:
              '<p>โทนแดง ให้อารมณ์สปอร์ตพรีเมียม <span>พร้อมโลโก้ X</span></p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt237ece902badb672/65ab36759b1ffed582e0e8e0/hi-lander-interior-2-infotainment-display.jpg',
              alt: 'Hi-Lander Interior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt36343b83a8ece6a9/65ab3658d48d3d7e2aced3fa/hi-lander-interior-2-infotainment-display-desktop.jpg',
              alt: 'Hi-Lander Interior',
            },
            title: 'ใหม่! หน้าจอระบบสัมผัส Infotainment <span>8 นิ้ว</span>',
            description:
              '<p>ดีไซน์สปอร์ตโทนแดง รองรับระบบ Wireless Android Auto<sup>*</sup> และ Wireless Apple CarPlay<sup>*</sup> หน้าจอทำงานแบบ Multitasking System เชื่อมต่อข้อมูลกับ Integrated MID แสดงผลได้หลากหลายฟังก์ชัน</p><p><small><sup>*</sup>เฉพาะสมาร์ทโฟนรุ่นที่รองรับการใช้งาน</small></p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt11d2062bd9d864b0/65a7798c18af00f2840a7429/hi-lander-interior-3-paddle-shift.jpg',
              alt: 'Hi-Lander Interior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltc45117d98cf02a6d/65a7798cd7d8564424b4e401/hi-lander-interior-3-paddle-shift-desktop.jpg',
              alt: 'Hi-Lander Interior',
            },
            title: 'ใหม่! Sequential Paddle Shift ที่<span>พวงมาลัย</span>',
            description: '<p>เปลี่ยนเกียร์ง่ายเพียงปลายนิ้ว ขับสนุกเร้าใจ</p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt5ef48fed0668f9f5/65ab36a6bad37d520d9e09e6/hi-lander-interior-4-console.jpg',
              alt: 'Hi-Lander Interior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt27592304d03d9d84/65ab36936e07462320fbaaf5/hi-lander-interior-4-console-desktop.jpg',
              alt: 'Hi-Lander Interior',
            },
            title: 'ใหม่! คอนโซลดีไซน์แบบ Iron Structure',
            description:
              '<p>เพิ่มความเท่อย่างมีสไตล์ หรูหราด้วยสีเทาดำ พร้อม<span>โลโก้ X</span> ที่คอนโซลหน้า</p>',
          },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt758168bea536f935/65a7798c8c124a6fba159607/hi-lander-interior-5-seat.jpg',
              alt: 'Hi-Lander Interior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltdc37eaee047e361c/65a7798c6e0746058cfb9817/hi-lander-interior-5-seat-desktop.jpg',
              alt: 'Hi-Lander Interior',
            },
            title: 'ใหม่! เบาะนั่งดีไซน์สปอร์ตพรีเมียม',
            description:
              '<p>ดีไซน์เบาะโอบกระชับ พร้อม<span>โลโก้ X</span> ปักด้ายแดง และเทคโนโลยี COOLMAX ลดการสะสมความร้อน</p>',
          },
          // {
          //   image: {
          //     src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt8052031836fd285e/65a7798cc3bf060403fdeb13/hi-lander-interior-6-charging-socket.jpg',
          //     alt: 'Hi-Lander Interior',
          //   },
          //   imageDesktop: {
          //     src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltafa454a7f2e20e25/65a7798cfb1060f33ba4044a/hi-lander-interior-6-charging-socket-desktop.jpg',
          //     alt: 'Hi-Lander Interior',
          //   },
          //   title: 'ใหม่! Charging Socket',
          //   description:
          //     '<p>รองรับ USB-C ทั้งที่นั่งด้านหน้า และด้านหลัง ชาร์จได้รวดเร็ว</p>',
          // },
          {
            image: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt3d259e06edf03dc7/65ab38fcdbd0c33b00ad3c63/hi-lander-interior-7-gear.jpg',
              alt: 'Hi-Lander Interior',
            },
            imageDesktop: {
              src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt0aea9f7f511beec4/65ab38e5bad37d0b819e09e8/hi-lander-interior-7-gear-desktop.jpg',
              alt: 'Hi-Lander Interior',
            },
            title: 'ชุดคันเกียร์พร้อมเบรกมือ',
            description:
              '<p>ดีไซน์พิเศษหุ้มหนัง เดินด้ายแดง เสริมอารมณ์สปอร์ต</p>',
          },
        ],
      },
    ],
  } as IMY24ProductExteriorInterior,
  PRODUCT_CUSTOMIZE_DATA: {
    theme: 'dark',
    active: true,
    model: 'x-series',
    isMiura: false,
    backdrop: true,
    menu: {
      hash: '#customize',
      label: 'สำรวจรถของคุณ',
    },
    headline: {
      preTitle: 'สำรวจรถของคุณ',
      title: '<strong>PRODUCT</strong> CUSTOMIZE',
      description: '',
      buttons: [],
      level: 1,
    },
  } as ProductCustomizeProps,
  PRODUCT_POWER_DATA: {
    active: true,
    theme: 'dark',
    section: 'power',
    menu: {
      hash: '#power',
      label: 'เครื่องยนต์และระบบส่งกำลัง',
    },
    headline: {
      preTitle: 'เครื่องยนต์และระบบส่งกำลัง',
      title: 'POWER',
      description: '<p>ปลดปล่อยพลังเต็มแม็กซ์ ทะลุทุกขีดจํากัด</p>',
      buttons: [
        {
          label: 'ดาวน์โหลดโบรชัวร์',
          url: X_SERIES_MENU.brochure,
          border: true,
          isMinWidth: true,
          target: '_blank',
          color: 'button-white',
        },
      ],
    },
    highlight: {
      bg: {
        src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta0ec9e72f017e737/65a654d318123e576e26f0f5/x-series-power-bg.jpg',
        alt: 'Power',
      },
      bgDesktop: {
        src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blte191245df5e65de7/65ae25a7c992b77f79b8b474/x-series-power-bg-desktop.jpg',
        alt: 'Power',
      },
    },
    items: [
      {
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt961b45a1964c78a8/6605178fb1b99a2e2c30de1f/lcv-e5-1-9-mobile.jpg',
          alt: 'ISUZU 1.9 Ddi Blue Power',
        },
        imageDesktop: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt69bf495ae3cb25d8/660517993110d0148a0674d8/lcv-e5-1-9-desktop.jpg',
          alt: 'ISUZU 1.9 Ddi Blue Power',
        },
        title: 'ISUZU 1.9 Ddi Blue Power',
        description:
          '<p>­เครื่องยนต์อีซูซุ 1.9 ดีดีไอ <span>บลูเพาเวอร์</span> รุ่น RZ4E-TC ออกตัวเร็ว เร่งแซงทันใจ ที่สุดแห่งความประหยัดน้ำมันจากอีซูซุ กำลังสูงสุด <span>150 แรงม้า</span> <span>ที่ 3,600</span> <span>รอบ/นาที</span> แรงบิดสูงสุด 350 <span>นิวตัน–เมตร</span> <span>ที่ 1,800–2,600</span> <span>รอบ/นาที</span></p>',
      },
      {
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb9bdc2d14ba5701a/65af802602a665c46e92ddfd/x-series-power-2-climbing-angle-and-turning-direction.jpg',
          alt: 'Power',
        },
        imageDesktop: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb99acec160943371/65af801bc7bb16825da2a564/x-series-power-2-climbing-angle-and-turning-direction-desktop.jpg',
          alt: 'Power',
        },
        title: 'ระบบแสดงองศามุมปีนไต่และทิศทางการเลี้ยว',
        description:
          '<p>ลุยได้อย่างมั่นใจ บนทุกองศาความลาดเอียง ผ่านหน้าจอ Integrated MID และ Infotainment Display</p>',
      },
      {
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt3cce8c335aec5896/65ab372541047fcee44e7fb7/x-series-power-3-6-speed-automatic-transmission.jpg',
          alt: 'Power',
        },
        imageDesktop: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt90bf0f55a5134c20/65ab370a7fc0006a722245ca/x-series-power-3-6-speed-automatic-transmission-desktop.jpg',
          alt: 'Power',
        },
        title: 'เกียร์อัตโนมัติ 6 สปีด',
        description:
          '<p>พร้อมโหมดการขับขี่แบบสปอร์ต Rev Tronic และ Sequential Paddle Shift ที่พวงมาลัย</p>',
      },
      {
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt58ae6db6cae2b1f6/65ab37491307909a19cc08a0/x-series-power-4-6-speed-manual-transmission.jpg',
          alt: 'Power',
        },
        imageDesktop: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt76684ee83ca530b9/65ab3737dbd0c3bbcaad3c61/x-series-power-4-6-speed-manual-transmission-desktop.jpg',
          alt: 'Power',
        },
        title: 'เกียร์ธรรมดา 6 สปีด',
        description:
          '<p>พร้อมแจ้งเตือนการเปลี่ยนเกียร์ในรอบความเร็ว <span>ที่เหมาะสม</span>ด้วย Genius Sport Shift ออกตัว<span>ดีเยี่ยม</span> เร่งแรงแซงเร็ว</p>',
      },
    ],
  } as IMY24ProductExteriorInterior,
  PRODUCT_SAFETY_DATA: {
    active: true,
    theme: 'dark',
    model: 'x-series',
    layout: 'safety',
    menu: {
      hash: '#safety',
      label: 'ความปลอดภัย',
    },
    headline: {
      preTitle: 'ความปลอดภัย',
      title: 'PROTECTION',
      buttons: [],
    },
    items: [
      {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt7bbb3b561e035c15/65b37492c600053d9cd5a19b/x-series-safety-5-ess.jpg',
          alt: 'ESS (Emergency Stop Signal)',
        },
        title: 'ESS (Emergency Stop Signal)',
        description:
          '<p>ระบบไฟฉุกเฉินจะกะพริบอัตโนมัติ เมื่อมีการเบรก<span>กะทันหัน</span></p>',
      },
      {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blta74ff5968a3ab32f/65af8d24daaa5020309c9476/x-series-safety-6-abs-ebd-ba.jpg',
          alt: 'ABS / EBD / BA',
        },
        title: 'ABS / EBD / BA',
        description: `<ul>
          <li>ระบบป้องกันล้อล็อกขณะเบรกแบบอิเล็กทรอนิกส์ ABS (Anti-Lock Brake System) ชนิด <span>4-Channel</span> <span>4-Sensor</span></li> <li>ระบบช่วยกระจายแรงเบรกให้สัมพันธ์กับน้ำหนักบรรทุกของรถ EBD (Electronic Brake-force Distribution)</li>
          <li>ระบบช่วยเพิ่มแรงเบรกอัตโนมัติ เมื่อเบรก<span>กะทันหัน</span> BA (Brake Assist)</li>
          </ul>`,
      },
      {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltd4c3421d695a2d4d/65a88d56c3bf06f223fdf11f/x-series-safety-7-esc-tcs.jpg',
          alt: 'ESC / TCS',
        },
        title: 'ESC / TCS',
        description: `<ul>
          <li>ระบบควบคุมการทรงตัว ESC (Electronic Stability Control)</li>
          <li>ระบบป้องกันล้อหมุนฟรีขณะออกตัว TCS (Traction Control System)</li>
          </ul>`,
      },
      {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltf7c0b8546c197d42/65a9fe57c7bb1697aca294f0/x-series-safety-8-hsa-hdc.jpg',
          alt: 'HSA / HDC',
        },
        title: 'HSA / HDC',
        description:
          '<ul><li>ระบบช่วยออกตัวบนทางลาดชัน HSA (Hill Start Assist)</li><li>ระบบควบคุมความเร็วลงทางลาดชัน HDC (Hill Descent Control)</li></ul>',
      },
      {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        image: {
          src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt1bd3e6a5ceeeb6d8/65ab347949a17d880bd00011/x-series-safety-9-air-bags.jpg',
          alt: 'Dual SRS Airbags',
        },
        title: 'Dual SRS Airbags',
        description:
          '<p>แอร์แบคคู่หน้า พร้อม Crash Unlock ปลดล็อกประตูอัตโนมัติ เมื่อแอร์แบคทำงาน</p>',
      },
    ],
  } satisfies IMY24ProductSafetyInnovation,
  PRODUCT_NAVIGATION_DATA: {
    active: true,
    title: X_SERIES_DATA.label,
    price: X_SERIES_DATA.price,
    buttons: [
      {
        label: 'คำนวณค่างวด',
        url: '/calculator?model=x-series',
        color: 'button-gray-light',
        size: 'md',
        isMinWidth: true,
      },
      {
        label: 'สนใจรถ',
        url: '/register',
        color: 'button-red',
        size: 'md',
        isMinWidth: true,
      },
    ],
  } as IMY24ProductNavigation,
  PRODUCT_LINEUP_DATA: {
    active: true,
    headline: {
      title: 'สำรวจรุ่นรถของเรา',
    },
    items: PRODUCT_LINEUP_DATA,
    modelSlide: getModelLineupId('x-series'),
  } as IMY24ProductLineup,
  PRODUCT_CTA_DATA: {
    ...getCta('x-series'),
  },
};
